import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../services/util.service';
import { BuildInfo } from '../../model/BuildInfo';

@Component({
  selector: 'app-backend-version',
  templateUrl: './backend-version.component.html'
})
export class BackendVersionComponent implements OnInit {
  buildInfo: BuildInfo;

  constructor(private utilService: UtilService) { }

  ngOnInit() {
    this.utilService.getBackendBuildInfo()
      .subscribe(buildInfo => {
        this.buildInfo = buildInfo;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/backend-version/backend-version.component.ts